import { Type } from '@deqo/foundation';
import {
    PodSession,
    PodSessionWithModelFeatureType,
    PodSessionWithPresenceFeatureType,
    PodSessionWithRecordSetFeatureType,
    PodSessionWithRelayFeatureType,
    PodSessionWithTopicFeatureType,
    WithModelFeature,
    WithPresenceFeature,
    WithRecordSetFeature,
    WithRelayFeature,
    WithTopicFeature
} from '@deqo/podopolis';

export type EditorPodSession =
    InstanceType<PodSessionWithModelFeatureType> &
    InstanceType<PodSessionWithPresenceFeatureType> &
    InstanceType<PodSessionWithRelayFeatureType> &
    InstanceType<PodSessionWithTopicFeatureType> &
    InstanceType<PodSessionWithRecordSetFeatureType>;

export const EditorPodSession: Type<EditorPodSession> =
    WithRelayFeature(
        WithPresenceFeature(
            WithTopicFeature(
                WithRecordSetFeature(
                    WithModelFeature(PodSession)
                )
            )
        )
    );
